class ProductQuery {
	constructor() {
		this.query = null;
		this.queryStringGlobal = "";
		this.utm_source = null;
		this.utm_medium = null;
		this.utm_content = null;
		this.utm_campaign = null;
	}

	getQueryString() {
		if (this.queryStringGlobal !== "") {
			const globalQuery = this.queryStringGlobal;
			this.queryStringGlobal = "";
			return globalQuery;
		} else {
			return this.getQuery();
		}
	}

	setQuery(qs) {
		if (qs.query) {
			this.query = qs.query;
		}

		if (qs.utm_source) {
			this.utm_source = qs.utm_source;
		}

		if (qs.utm_medium) {
			this.utm_medium = qs.utm_medium;
		}

		if (qs.utm_campaign) {
			this.utm_campaign = qs.utm_campaign;
		}

		if (qs.utm_content) {
			this.utm_content = qs.utm_content;
		}
	}

	getQuery() {
		const productQuery = {};

		if (this.query) {
			productQuery.query = this.query;
		}

		if (this.utm_source) {
			productQuery.utm_source = this.utm_source;
		}

		if (this.utm_medium) {
			productQuery.utm_medium = this.utm_medium;
		}

		if (this.utm_campaign) {
			productQuery.utm_campaign = this.utm_campaign;
		}

		if (this.utm_content) {
			productQuery.utm_content = this.utm_content;
		}

		return productQuery;
	}
}

export { ProductQuery };
